module.exports = __webpack_public_path__ + "static/media/logo_govbr.00955208.png";